export const enumLabels = {
  HeadingStyle: {
    's-fold': 'S-Fold / Wave',
    'pinch-pleat': 'Pinch Pleat',
    'eyelet': 'Eyelet / Grommet',
    'pencil-pleat': 'Pencil Pleat'
  },
  MountType: {
    'wall': 'Wall / Face-Fit',
    'ceiling': 'Ceiling / Top-Fit'
  },
  DropStyle: {
    'floating': 'Floating',
    'touching': 'Just Touching',
    'puddle': 'Puddle',
    'sill-length': 'Sill Length'
  },
  FabricType: {
    'linen': 'Linen',
    'velvet': 'Velvet',
    'cotton': 'Cotton',
    'blend': 'Blend',
    'silk': 'Silk'
  },
  Opacity: {
    'sheer': 'Sheer',
    'light-filtering': 'Light Filtering',
    'room-darkening': 'Room Darkening',
    'blockout': 'Blockout'
  },
  LiningType: {
    'none': 'None (Unlined)',
    'standard': 'Standard',
    'thermal': 'Thermal',
    'blackout': 'Blackout'
  },
  HardwareStyle: {
    'architectural': 'Architectural',
    'decorative': 'Decorative'
  }
};

export const getLabel = (type: keyof typeof enumLabels, value: string) => {
  if (!value) return '';
  const map = enumLabels[type] as Record<string, string>;
  if (map && map[value]) return map[value];
  return value.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};
